var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0098 20.959H6V36H12.0098V20.959Z",
    fill: "#9B62FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0068 11.6309H15.9961V36H22.0068V11.6309Z",
    fill: "#9B62FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0029 15.375H25.9922V36H32.0029V15.375Z",
    fill: "#9B62FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.001 6H35.9902V36H42.001V6Z",
    fill: "#C3A0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.001 6H35.9902V16H42.001V6Z",
    fill: "#DBC6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 38H42C42.5304 38 43.0391 38.2107 43.4142 38.5858C43.7893 38.9609 44 39.4696 44 40C44 40.5304 43.7893 41.0391 43.4142 41.4142C43.0391 41.7893 42.5304 42 42 42H6C5.46957 42 4.96086 41.7893 4.58579 41.4142C4.21071 41.0391 4 40.5304 4 40C4 39.4696 4.21071 38.9609 4.58579 38.5858C4.96086 38.2107 5.46957 38 6 38Z",
    fill: "#C3A0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65948 31.2212C5.43743 31.2213 5.22164 31.1476 5.04609 31.0117C4.87054 30.8757 4.7452 30.6852 4.68982 30.4702C4.63444 30.2552 4.65216 30.0278 4.7402 29.824C4.82823 29.6201 4.98158 29.4513 5.17608 29.3442L18.5189 21.9985C18.7004 21.8993 18.908 21.8584 19.1136 21.8813L28.8528 22.977L42.305 17.3735C42.5498 17.2725 42.8247 17.2726 43.0694 17.3739C43.3141 17.4752 43.5087 17.6693 43.6106 17.9138C43.7124 18.1583 43.7131 18.4332 43.6127 18.6783C43.5122 18.9233 43.3187 19.1186 43.0745 19.2212L29.3831 24.9243L28.886 24.9946L19.2054 23.9048L6.14092 31.0981L5.65948 31.2212Z",
    fill: "#DBC6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDeliveryIcon);
export default __webpack_public_path__ + "static/media/PaymentDeliveryIcon.7fde90262bab89eda605759ee0c219d4.svg";
export { ForwardRef as ReactComponent };